const GET_LICENSE_DATA = 'GET_LICENSE_DATA';
const SET_LICENSE_DATA  = 'SET_LICENSE_DATA';
const GET_LICENSES_HISTORICAL = 'GET_LICENSES_HISTORICAL';
const SET_LICENSES_HISTORICAL  = 'SET_LICENSES_HISTORICAL';
const GET_BALANCE_DATA = 'GET_BALANCE_DATA';
const SET_BALANCE_DATA = 'SET_BALANCE_DATA';
const SAVE_INVOICE_DATA = 'SAVE_INVOICE_DATA';
const GET_INVOICE_DATA = 'GET_INVOICE_DATA';
const SET_INVOICE_DATA = 'SET_INVOICE_DATA';
const SET_INVOICE_FIELD = 'SET_INVOICE_FIELD';
const SET_FREE_LICENSE_STATUS = 'SET_FREE_LICENSE_STATUS';
const SET_OVERFLOW = 'SET_OVERFLOW';

const setInvoiceField = data=>{
    return{
        type:SET_INVOICE_FIELD,
        data
    }
}

const saveInvoiceData = data =>{
    return {
        type: SAVE_INVOICE_DATA,
        data
    }
}

const getInvoiceData = () =>{
    return {
        type:GET_INVOICE_DATA
    }
}

const setInvoiceData = data =>{
    return {
        type: SET_INVOICE_DATA,
        data
    }
}

const getLicenseData = data => {
    return {
        type: GET_LICENSE_DATA,
        data
    };
}

const setLicenseData = data => {
    return {
        type: SET_LICENSE_DATA,
        data
    };
}

const getLicensesHistorical = data => {
    return {
        type: GET_LICENSES_HISTORICAL,
        data
    }
}

const setLicensesHistory = data => {
    return {
        type: SET_LICENSES_HISTORICAL,
        data
    }
}

const getBalanceData = data => {
    return {
        type: GET_BALANCE_DATA,
        data
    };
}

const setBalanceData = data => {
    return {
        type: SET_BALANCE_DATA,
        data
    };
}
const setOverflow = data => {
    return {
        type: SET_OVERFLOW,
        data
    };
}

const setFreeLicenseStatus = status => {
    return{
        type:SET_FREE_LICENSE_STATUS,
        status
    }
}

export default {
    types: {
        GET_LICENSE_DATA,
        SET_LICENSE_DATA,
        GET_LICENSES_HISTORICAL,
        SET_LICENSES_HISTORICAL,
        GET_BALANCE_DATA,
        SET_BALANCE_DATA,
        SET_INVOICE_DATA,
        GET_INVOICE_DATA,
        SAVE_INVOICE_DATA,
        SET_INVOICE_FIELD,
        SET_FREE_LICENSE_STATUS,
        SET_OVERFLOW
    },    
    actions: {
        getLicenseData,
        setLicenseData,
        getLicensesHistorical,
        setLicensesHistory,
        getBalanceData,
        setBalanceData,
        setInvoiceData,
        getInvoiceData,
        saveInvoiceData,
        setInvoiceField,
        setFreeLicenseStatus,
        setOverflow
    }
}